import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import * as _ from "lodash";
import * as moment from "moment";
import { Alert } from "src/app/shared/class/Alert";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { ReportImageDialogComponent } from "../report-image-dialog/report-image-dialog.component";
moment.locale("pt-br");
export class ReportInventoryComponent {
    constructor(authService, spinner, reportService, serviceRequestService, userService, fb, excelService, invetoryTypePipe, router, dialog) {
        this.authService = authService;
        this.spinner = spinner;
        this.reportService = reportService;
        this.serviceRequestService = serviceRequestService;
        this.userService = userService;
        this.fb = fb;
        this.excelService = excelService;
        this.invetoryTypePipe = invetoryTypePipe;
        this.router = router;
        this.dialog = dialog;
        this.goback = "";
        this.userLogged = {};
        this.startDate = new FormControl();
        this.minStartDate = new Date();
        this.strStartDate = "";
        this.endDate = new FormControl();
        this.minEndDate = null;
        this.strEndDate = "";
        this.agentOptions = [];
        this.filteredAgentOptions = [];
        this.groupedInventory = [];
        this.etaInventoried = [];
        this.loaded = false;
        this.itemsPerPage = 30;
        this.currentPage = 1;
        this.itemsPerPageEta = 30;
        this.currentPageEta = 1;
        this.etaIndicators = {};
        this.invetoryIndicators = {};
        this.serviceLocalOptions = [];
        this.selectedCompany = {};
        this.optionsCompany = [];
        this.filteredOptionsCompany = this.optionsCompany;
        this.selectedRegional = {};
        this.optionsRegional = [];
        this.filteredOptionsRegional = this.optionsRegional;
        this.selectedServiceLocal = {};
        this.optionsServiceLocal = [];
        this.filteredOptionsServiceLocal = this.optionsServiceLocal;
        this.getExcelData = (inventory) => {
            const jsonData = [];
            _.map(inventory, (data) => {
                jsonData.push({
                    CLIENTE: data.empresa,
                    REGIONAL: data.regional,
                    ETA: data.eta,
                    DATA: data.data_ref,
                    TECNICO: data.tecnico,
                    BEM: data.bem,
                    IMAGEM: data.e_fotobem,
                    TIPO: this.invetoryTypePipe.transform(data.tipo),
                    DETALHE: data.tipo_detalhe,
                    ITEM: data.descricao,
                    QUANTIDADE: data.e_qtd,
                    OBSERVACAO: data.e_obs,
                    PLAQUETA: data.e_plaqueta,
                });
            });
            return jsonData;
        };
        this.getEtaExcelData = (inventory) => {
            const jsonData = [];
            _.map(inventory, (data) => {
                jsonData.push({
                    CLIENTE: data.empresa,
                    REGIONAL: data.regional,
                    ETA: data.eta,
                    DATA: data.data_ref,
                    TECNICO: data.tecnico,
                });
            });
            return jsonData;
        };
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.loadForm();
            this.userLogged = this.authService.getUserLogged();
            const userData = yield this.userService.searchUser(this.userLogged.id);
            if (userData.type === globalConst.defaults.user.client) {
                this.router.navigate(["/home"]);
            }
            else {
                try {
                    // this.spinner.show();
                    yield this.loadCompanyOptions();
                    yield this.loadRegionalOptions();
                    yield this.loadServiceLocalOptions();
                    this.loadTabData();
                }
                catch (error) {
                    this.spinner.hide();
                }
            }
        });
    }
    loadForm() {
        this.form = new FormGroup({
            startDate: new FormControl(""),
            endDate: new FormControl(""),
            company: new FormControl("T"),
            regional: new FormControl(null),
            serviceLocal: new FormControl(null),
            agent: this.fb.control(""),
            bem: this.fb.control(""),
            plaqueta: this.fb.control(""),
        });
    }
    loadCompanyOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.optionsCompany.push({ id: 0, description: "Aguarde Carregando..." });
                this.filteredOptionsCompany = this.optionsCompany;
                this.selectedCompany = this.filteredOptionsCompany.find((obj) => obj.id == 0);
                this.form.controls.company.setValue(this.selectedCompany);
                const data = yield this.serviceRequestService.getCompanies();
                this.optionsCompany =
                    this.authService.getUserLogged().type ===
                        globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.authService.getUserLogged().companiesAssociate;
                this.optionsCompany.push({ id: 0, description: "TODOS" });
                this.filteredOptionsCompany = this.optionsCompany;
                this.selectedCompany = this.filteredOptionsCompany.find((obj) => obj.id == 0);
                this.form.controls.company.setValue(this.selectedCompany);
                if (!this.optionsCompany.length) {
                    Alert.warning(Alert.getMessage().errors.company.emptySearch);
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadRegionalOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.optionsRegional = [];
                this.optionsRegional.push({
                    id: 0,
                    description: "Aguarde Carregando...",
                });
                this.filteredOptionsRegional = this.optionsRegional;
                this.selectedRegional = this.filteredOptionsRegional.find((obj) => obj.id == 0);
                this.form.controls.regional.setValue(this.selectedRegional);
                //
                const data = yield this.serviceRequestService.getRegionals();
                this.optionsRegional =
                    this.authService.getUserLogged().type ===
                        globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.authService.getUserLogged().regionalsAssociate;
                //
                if (this.selectedCompany.id > 0) {
                    this.optionsRegional = this.optionsRegional.filter((obj) => obj.companyAlternativeIdentifier ===
                        this.selectedCompany.alternativeIdentifier);
                }
                this.optionsRegional.push({ id: 0, description: "TODAS" });
                this.filteredOptionsRegional = this.optionsRegional;
                this.selectedRegional = { id: 0, description: "TODAS" };
                this.form.controls.regional.setValue(this.selectedRegional);
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadServiceLocalOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.optionsServiceLocal = [];
                this.optionsServiceLocal.push({
                    id: 0,
                    description: "Aguarde Carregando...",
                });
                this.filteredOptionsServiceLocal = this.optionsServiceLocal;
                this.selectedServiceLocal = this.filteredOptionsServiceLocal.find((obj) => obj.id == 0);
                this.form.controls.serviceLocal.setValue(this.selectedServiceLocal);
                const data = yield this.serviceRequestService.getServiceLocals();
                this.optionsServiceLocal =
                    this.authService.getUserLogged().type ===
                        globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.authService.getUserLogged().serviceLocalsAssociate;
                if (this.selectedRegional.id == 0) {
                    const auxServiceLocal = [];
                    this.form.controls.serviceLocal.setValue(null);
                    this.optionsRegional.map((regional) => {
                        // tslint:disable-next-line: max-line-length
                        this.optionsServiceLocal
                            .filter((obj) => obj.regionalId === regional.id)
                            .map((serviceLocal) => auxServiceLocal.push(serviceLocal));
                    });
                    this.optionsServiceLocal = auxServiceLocal;
                }
                else {
                    this.optionsServiceLocal = this.optionsServiceLocal.filter((obj) => obj.regionalId === this.selectedRegional.id);
                }
                this.optionsServiceLocal.push({ id: 0, description: "TODAS" });
                this.filteredOptionsServiceLocal = this.optionsServiceLocal;
                this.selectedServiceLocal = { id: 0, description: "TODAS" };
                this.form.controls.serviceLocal.setValue(this.selectedServiceLocal);
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    changeCompany() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.spinner.show();
                yield this.loadRegionalOptions();
                yield this.loadServiceLocalOptions();
                this.spinner.hide();
            }
            catch (error) {
                this.spinner.hide();
                Helper.handleError(error);
            }
        });
    }
    changeServiceLocal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const control = this.form.controls.serviceLocal;
            if (!_.isNull(control.value) && control.value !== "0") {
                this.selectedRegional = this.optionsRegional.find((obj) => obj.id === control.value.regionalId);
                this.form.controls.regional.setValue(this.selectedRegional);
                this.selectedCompany = this.filteredOptionsCompany.find((obj) => obj.alternativeIdentifier ==
                    this.selectedRegional.companyAlternativeIdentifier);
                this.form.controls.company.setValue(this.selectedCompany);
            }
        });
    }
    onSubmit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validateForm()) {
                this.spinner.show();
                this.loaded = false;
                this.currentPage = 1;
                const data = yield this.reportService.getInventory(this.getQueryParams());
                this.loaded = true;
                this.groupedInventory = [];
                //O campo status só vem preenchido quando há algum erro
                if (_.isUndefined(data.status)) {
                    let lastTask = "";
                    _.map(data, (inventory) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        if (inventory.tarefa !== lastTask) {
                            //Uma Nova tarefa
                            this.groupedInventory.push(Object.assign({}, inventory, { tipo: 1, descricao: "", tipo_detalhe: "" }));
                        }
                        else {
                            let taskFounded = this.groupedInventory.find((obj) => obj.tarefa === inventory.tarefa);
                            this.groupedInventory.push(Object.assign({}, inventory, { bem: taskFounded.bem, tipo: !_.isNull(inventory.intermediario)
                                    ? 2
                                    : !_.isNull(inventory.complementar)
                                        ? 3
                                        : 1, tipo_detalhe: !_.isNull(inventory.intermediario)
                                    ? inventory.intermediario
                                    : !_.isNull(inventory.complementar)
                                        ? inventory.complementar
                                        : "" }));
                        }
                        lastTask = inventory.tarefa;
                    }));
                }
                this.loadTabData();
                this.spinner.hide();
            }
            else {
                this.spinner.hide();
                this.loaded = false;
                Alert.warning(Alert.getMessage().errors.requiredFilters);
            }
        });
    }
    getQueryParams() {
        const params = [];
        const filters = this.form.controls;
        if (!_.isNull(filters.company.value) && filters.company.value.id > 0) {
            params.push({
                id: "company",
                value: filters.company.value.id,
            });
        }
        /* if (!_.isNull(filters.startDate.value) && filters.startDate.value !== "") {
          params.push({
            id: "startDate",
            value: moment(filters.startDate.value).format("YYYY-MM-DD"),
          });
        }
    
        if (!_.isNull(filters.endDate.value) && filters.endDate.value !== "") {
          params.push({
            id: "endDate",
            value: moment(filters.endDate.value).format("YYYY-MM-DD"),
          });
        } */
        if (!_.isNull(this.selectedRegional) && this.selectedRegional.id > 0) {
            params.push({ id: "regional", value: this.selectedRegional.id });
        }
        console.log(this.selectedServiceLocal);
        if (!_.isNull(this.selectedServiceLocal) &&
            this.selectedServiceLocal.id > 0) {
            params.push({ id: "serviceLocal", value: this.selectedServiceLocal.id });
        }
        if (!_.isEmpty(filters.bem.value) && filters.bem.value != "") {
            params.push({ id: "bem", value: filters.bem.value });
        }
        if (!_.isEmpty(filters.plaqueta.value) && filters.plaqueta.value != "") {
            params.push({ id: "plaqueta", value: filters.plaqueta.value });
        }
        return this.prepareQueryParams(params);
    }
    prepareQueryParams(params) {
        let queryParams = "";
        params.map((param) => {
            queryParams = queryParams === "" ? "" : `${queryParams}&`;
            queryParams = `${queryParams}${param.id}=${param.value}`;
        });
        return queryParams;
    }
    validateForm() {
        if (
        /* this.form.controls.startDate.value !== "" ||
        this.form.controls.endDate.value !== "" ||
        this.form.controls.agent.value !== "" */
        !_.isNull(this.form.controls.company.value) ||
            !_.isNull(this.form.controls.regional.value) ||
            !_.isNull(this.form.controls.serviceLocal.value) ||
            this.form.controls.bem.value !== "" ||
            this.form.controls.plaqueta.value !== "") {
            return true;
        }
        else {
            return false;
        }
    }
    exportExcel() {
        this.excelService.exportAsExcelFile(this.getExcelData(this.groupedInventory), "inventario");
    }
    /**
     * @description Método que faz a consulta no momento de mudança de aba
     */
    loadTabData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validateForm()) {
                this.spinner.show();
                this.loaded = false;
                let data;
                switch (this.tabGroup.selectedIndex) {
                    case 0:
                        this.currentPage = 1;
                        this.invetoryIndicators = {};
                        this.groupedInventory = [];
                        data = yield this.reportService.getInventory(this.getQueryParams());
                        //O campo status só vem preenchido quando há algum erro
                        if (_.isUndefined(data.status)) {
                            let lastTask = "";
                            let lastAsset = "";
                            _.map(data, (inventory) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                if (inventory.tarefa !== lastTask.tarefa) {
                                    //Uma Nova tarefa
                                    this.groupedInventory.push(Object.assign({}, inventory, { tipo: 1, descricao: "", tipo_detalhe: "" }));
                                }
                                else {
                                    let taskFounded = this.groupedInventory.find((obj) => obj.tarefa === inventory.tarefa);
                                    if (inventory.bem !== null ||
                                        lastTask.bem !== null ||
                                        lastAsset === "") {
                                        lastAsset =
                                            inventory.bem !== null ? inventory.bem : lastTask.bem;
                                    }
                                    this.groupedInventory.push(Object.assign({}, inventory, { bem: lastAsset, tipo: !_.isNull(inventory.intermediario)
                                            ? 2
                                            : !_.isNull(inventory.complementar)
                                                ? 3
                                                : 1, tipo_detalhe: !_.isNull(inventory.intermediario)
                                            ? inventory.intermediario
                                            : !_.isNull(inventory.complementar)
                                                ? inventory.complementar
                                                : "" }));
                                }
                                lastTask = inventory;
                            }));
                        }
                        this.invetoryIndicators =
                            yield this.reportService.getInventoryIndicators(this.getQueryParams());
                        break;
                    case 1: //Listando as Etas Inventariadas
                        this.currentPageEta = 1;
                        this.etaIndicators = {};
                        this.etaInventoried = [];
                        data = yield this.reportService.getEta(this.getQueryParams());
                        if (_.isUndefined(data.status)) {
                            data.sort((a, b) => a.empresa < b.empresa ? -1 : 1);
                            this.etaInventoried = data;
                        }
                        this.etaIndicators = yield this.reportService.getEtaIndicators(this.getQueryParams());
                        break;
                    default:
                        break;
                }
                this.loaded = true;
                this.spinner.hide();
            }
            else {
                this.loaded = false;
                this.spinner.hide();
                Alert.warning(Alert.getMessage().errors.requiredFilters);
            }
        });
    }
    exportEtaExcel() {
        this.excelService.exportAsExcelFile(this.getEtaExcelData(this.etaInventoried), "eta");
    }
    openImage(fotoBem) {
        this.dialog.open(ReportImageDialogComponent, {
            data: { imagePath: fotoBem },
        });
    }
    /** */
    filterOptionsCompany(value) {
        value = value.trim();
        this.filteredOptionsCompany = value
            ? this._filterCompany(value)
            : this.optionsCompany.slice();
    }
    _filterCompany(value) {
        const filterValue = value.toLowerCase();
        const searchName = this.optionsCompany.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.optionsCompany.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
    displayCompany(item) {
        return !_.isNull(item) ? item.description : "";
    }
    checkSelectedCompany(value) {
        setTimeout(() => {
            value = value.trim();
            if (value && _.isUndefined(this.selectedCompany.id))
                Alert.warning("Selecione uma Empresa Válida!").then(() => {
                    this.selectedCompany = null;
                });
        }, 250);
    }
    /** */
    filterOptionsRegional(value) {
        value = value.trim();
        this.filteredOptionsRegional = value
            ? this._filterRegional(value)
            : this.optionsRegional.slice();
    }
    _filterRegional(value) {
        const filterValue = value.toLowerCase();
        const searchName = this.optionsRegional.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.optionsRegional.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
    displayRegional(item) {
        return !_.isNull(item) ? item.description : "";
    }
    checkSelectedRegional(value) {
        setTimeout(() => {
            value = value.trim();
            if (value && _.isUndefined(this.selectedRegional.id))
                Alert.warning("Selecione uma Regional Válida!").then(() => {
                    this.selectedRegional = null;
                });
        }, 250);
    }
    /** */
    filterOptionsServiceLocal(value) {
        value = value.trim();
        this.filteredOptionsServiceLocal = value
            ? this._filterServiceLocal(value)
            : this.optionsServiceLocal.slice();
    }
    _filterServiceLocal(value) {
        const filterValue = value.toLowerCase();
        const searchName = this.optionsServiceLocal.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.optionsServiceLocal.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
    displayServiceLocal(item) {
        return !_.isNull(item) ? item.description : "";
    }
    checkSelectedServiceLocal(value) {
        setTimeout(() => {
            value = value.trim();
            if (value && _.isUndefined(this.selectedServiceLocal.id))
                Alert.warning("Selecione uma Localidade Válida!").then(() => {
                    this.selectedServiceLocal = null;
                });
        }, 250);
    }
}
